import * as React from "react";
import { routes } from "../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { ShopProductAdditionsListItem } from "./model/ShopProductAdditionsListSuccessResponse";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { TableCellLink } from "../../components/table-components/TableCellLink";

interface Props {
  productAddition: ShopProductAdditionsListItem;
}

export const ProductAdditionsListRow: React.FC<Props> = ({
  productAddition,
}) => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const href = routes.shopProductAdditionsEdit(
    organization,
    productAddition.id
  );

  return (
    <tr className="cursor-pointer">
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {productAddition.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {productAddition.title}
        </StyledText>
      </TableCellLink>
    </tr>
  );
};
